import React from "react";
import useFeatureToggles from "src/core/common/hooks/useFeatureToggles";
import useIdentityVerificationProps from "src/integrations/identityVerification/hooks/useIdentityVerificationProps";
import {IdentityVerification} from "src/integrations/identityVerification/factory";
import AgeCheckerPoweredBy from "src/integrations/identityVerification/ageChecker/AgeCheckerPoweredBy";

export default function IdentityVerificationLogo() {
  const {hasVerificationRequiredQueryParam} = useIdentityVerificationProps();
  const toggles = useFeatureToggles();
  const identityVerificationService = toggles.getIdentityVerificationServiceName();

  if (!hasVerificationRequiredQueryParam) return null;

  switch (identityVerificationService) {
    case IdentityVerification.AGECHECKER:
      return <AgeCheckerPoweredBy />;
    default:
      return null;
  }
}
